import { ChangeDetectorRef, Component, Input, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { TranslateHelper } from '@app/_helpers';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import * as _ from 'lodash';
import { CurrencyFormatPipe } from '../../../../shared/pipes/currency-format.pipe';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor, NgClass } from '@angular/common';

@Component({
    selector: 'app-plan-details',
    templateUrl: './plan-details.component.html',
    styleUrls: ['./plan-details.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, MatIconModule, MatDividerModule, FormsModule, ReactiveFormsModule, MatCheckboxModule, NgClass, ExtendedModule, CurrencyFormatPipe, TranslateModule]
})
export class PlanDetailsComponent implements AfterViewInit {

    @Input() form;
    @Input() plan;
    @Input() submitting = false;
    @Output() onSubmit = new EventEmitter();

    _id;
    extraServices: string[] = [];
    serviceCheckboxes = {};
    selectedServicesStatus: { [_id: string]: boolean } = {};

    constructor(
        private cdr: ChangeDetectorRef,
        public translateService: TranslateService,
        public translateHelper: TranslateHelper
    ) {
    }

    isBoolean(value): boolean {
        return typeof value === 'boolean';
    }

    ngAfterViewInit() {
        _.each(this.plan.services, (service) => {
            const _id = service._id;
            if (service.oneTimeFee?.applied == true || service.annualFee?.applied == true) {
                this.setService(service, true);
            } else {
                this.selectedServicesStatus[_id] = this.extraServices.includes(_id);
            }
        });
        this.cdr.detectChanges();
    }

    submit() {
        if (this.submitting) return;
        this.form.get('services')?.setValue(this.extraServices);
        this.onSubmit.emit();
    }

    isSelected(serviceId) {
        return this.extraServices.includes(serviceId);
    }

    toggleService(service: any) {
        this.setService(service, !this.selectedServicesStatus[service._id]);
    }

    setService(service: any, state: boolean) {
        if (state) {
            if (service.group && service.group?.length > 0) {
                let sameGroupIds = _.map(_.filter(this.plan.services || [], (serv) => { return serv.group == service.group }), '_id');
                if (sameGroupIds.length > 0) {
                    _.remove(this.extraServices, (serviceId) => { return sameGroupIds.includes(serviceId) });
                    _.each(sameGroupIds, (serviceId) => { this.selectedServicesStatus[serviceId] = false; });
                }
            }
            this.extraServices.push(service._id);
            this.extraServices = _.uniq(this.extraServices);
        } else {
            _.remove(this.extraServices, (serviceId) => { return serviceId == service._id; });
            this.selectedServicesStatus[service._id] = false;
        }
        this.selectedServicesStatus[service._id] = state;
        this.cdr.detectChanges();
    }

    updateServices(event, service) {
        this.setService(service, event.checked);
    }

}
